import { render, staticRenderFns } from "./projectenvironments.vue?vue&type=template&id=3296d460&"
import script from "./projectenvironments.vue?vue&type=script&lang=js&"
export * from "./projectenvironments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports